import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth } from '../services/auth';

/**
 * Enforces the MANDATORY phone-onboarding (name + email account key).
 *
 * `verifyPhoneOtp` signs the user in immediately, so a phone account exists with
 * no email until onboarding completes. Routing to /auth/register is only one
 * navigation — a back button or deep link to /home would otherwise bypass it.
 * This guard, applied to every authenticated route, redirects any signed-in but
 * incomplete profile back to the onboarding screen so the email key is always set.
 *
 * Runs AFTER authGuard; on its own it also covers the unauthenticated case.
 */
export const onboardingGuard: CanActivateFn = async () => {
  const auth = inject(Auth);
  const router = inject(Router);

  await auth.authReady;

  if (!auth.isAuthenticated()) return router.createUrlTree(['/auth']);
  if (auth.needsOnboarding()) return router.createUrlTree(['/auth/register']);
  return true;
};
